import authMiddleware from "@/middleware/auth";
import indexAuthView from "@/views/auth/indexAuthView";

export const signIn = () =>
  import(
    /* webpackChunkName: "userSignUpAndSignInFunctions" */ "@/components/auth/signIn"
  );
export const signUp = () =>
  import(
    /* webpackChunkName: "userSignUpAndSignInFunctions" */ "@/components/auth/signUp"
  );
export const forgotPassword = () =>
  import(
    /* webpackChunkName: "userConfirmAndPasswordsFunctions" */ "@/components/auth/forgotPassword"
  );
export const resetPassword = () =>
  import(
    /* webpackChunkName: "userConfirmAndPasswordsFunctions" */ "@/components/auth/resetPassword"
  );
export const emailVerify = () =>
  import(
    /* webpackChunkName: "userConfirmAndPasswordsFunctions" */ "@/components/auth/emailVerify"
  );
export const resendEmail = () =>
  import(
    /* webpackChunkName: "userConfirmAndPasswordsFunctions" */ "@/components/auth/resendEmail"
  );
export const signUpStatus = () =>
  import(
    /* webpackChunkName: "userConfirmAndPasswordsFunctions" */ "@/components/auth/signUpStatus"
  );

export default {
  path: "/",
  component: indexAuthView,
  redirect: "/sign-in",
  children: [
    {
      path: "sign-in",
      component: signIn,
      name: "signIn",
    },
    {
      path: "sign-up",
      component: signUp,
    },
    {
      path: "forgot-password",
      component: forgotPassword,
    },
    {
      path: "reset-password",
      component: resetPassword,
    },
    {
      path: "resend-email",
      component: resendEmail,
    },
    {
      path: "/sign-up-status",
      name: "SignUpStatus",
      component: signUpStatus,
      props: true,
    },
    {
      path: "/email-verify",
      name: "emailVerify",
      component: emailVerify,
    },
    {
      path: "/account-verified",
      redirect: "/email-verify",
    },
    {
      path: "/password/reset",
      redirect: "/reset-password",
    },
  ],
  beforeEnter: authMiddleware.isUnAuthenticatedUser,
};
